import { useEffect } from "react";
import { useSignupDialog } from "@/contexts/SignupDialogContext";
import { useAuth } from "@/hooks/use-auth";
import { useLocation } from "wouter";

export default function SignupDialog() {
  const { isOpen, mode, closeSignupDialog } = useSignupDialog();
  const { isAuthenticated } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (isAuthenticated && isOpen) {
      closeSignupDialog();
      return;
    }

    if (isOpen && !isAuthenticated) {
      closeSignupDialog();
      if (mode === "login") {
        navigate("/sign-in");
      } else {
        navigate("/sign-up");
      }
    }
  }, [isOpen, isAuthenticated, mode, closeSignupDialog, navigate]);

  return null;
}
